{
  "maxFileSize": "200 KB",
  "access": "Access",
  "permissionsUserGrantedOurApp": "Permissions user has granted to our app",
  "notifications": "Notifications",
  "sendNotificationsAboutUpdatesImportant": "Send notifications about updates and important alerts.",
  "locationAccess": "Location Access",
  "accessLocationProvideRelevantServices": "Access location to provide relevant services",
  "camera": "Camera",
  "allowCapturingPhotosVideosScanning": "Allow capturing photos, videos, or scanning location",
  "microphone": "Microphone",
  "allowVoiceCallsRecordingsAudio": "Allow voice calls, recordings, or audio features.",
  "tags": "Tags",
  "tagsUpdatedSuccessfully": "Tags updated successfully",
  "assign": "Assign",
  "tagToMultipleUsers": "Tag to Multiple Users",
  "campuses": "Campus(es)",
  "deleteStaff": "Delete Staff",
  "staffDeleteWarning": "Are you sure you want to delete <bold>{{name}}</bold>? This action cannot be undone.",
  "viewStaff": "View Staff",
  "viewStudent": "View Student",
  "viewLawEnforcement": "View Law Enforcement",
  "archiveStaff": "Archive Staff",
  "archiveLawEnforcement": "Archive Law Enforcement",
  "archiveUserConfirm": "Are you sure you want to archive {{name}}?",
  "archiveUserNote": "They will move to the Archived list.",
  "assignTagMultipleUsers": "Assign Tag to Multiple Users",
  "userUpdated": "User updated",
  "userCreated": "User created",
  "userRoleMismatch": "Something went wrong, please try again later "
}
